import styled from 'styled-components';

const Heading = styled.h2`
  font-weight: 900;
  line-height: 110%;
  letter-spacing: -0.04em;
  width: 100%;
  text-align: ${props => props.textAlign};
`;

const Companies = styled.div`
  justify-content: space-around;
  align-items: center;
  display: flex;
  margin-top: 64px;
  padding: 0 28px;

  @media (max-width: 768px) {
    margin-top: 15px;
  }

  @media (max-width: 576px) {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: row;
  }
`;

const LogoContainer = styled.div`
  width: 135px;
  @media (max-width: 1200px) {
    width: 125px;
  }
  @media (max-width: 768px) {
    width: 85px;
  }
  @media (max-width: 576px) {
    width: 125px;
    margin: 48px 15px 0;
  }
`;

export { Heading, Companies, LogoContainer };
